
/**
 * A class to store an item which can be printed
 */
export class PrintItem {
  /**
   * HTML id of anchor
   */
  id: string;

  /**
   * Optional name
   */
  printDisplayName: string;

  /**
   * HTML Element
   */
  nativeElement: HTMLElement;

  constructor() {}
}
